const t=({firstName:t,lastName:a})=>`${t} ${a}`.trim();export{t as getUserFullName};
//# sourceMappingURL=useUser.helpers.js.map
